<template>
  <div class="full">

    <div class="full overlay lobby">
      <div class="lobby-wrapper">
        <div class="toolbar">
          <div class="center-v toolbar-title">
            <img class="toolbar-icon click" src="./img/back.svg" @click="$router.push('/choose-role')" alt="Logo" title="Logo" />

          </div>
          <div class="center-v toolbar-buttons">

            <img class="toolbar-icon click" src="./cj/logo.svg" @click="$emit('logo')" alt="Logo" title="Logo" />
            <img class="toolbar-icon click" src="./cj/chat.svg" @click="$emit('chat')" alt="Twitter" title="Twitter" />
            <img class="toolbar-icon click" src="./cj/twitter.svg" @click="$emit('twitter')" alt="Twitter" title="Twitter" />
            <img class="toolbar-icon click" src="./cj/help.svg" @click="$emit('game-rule')" alt="GameRule" title="GameRule" />
            <img class="toolbar-icon click" src="./cj/logout.svg" @click="$emit('logout')" alt="Logout" title="Logout" />
          </div>
        </div>

        <!--
        <h2>
          <a class="gp-home" href="/">Go Home</a>
        </h2> -->

        <!-- <input type="text" v-model="searchGame" /> -->

        <!-- <h2>
          Search Game
        </h2>
        <div>
          <input type="text" v-model="query" @input="searchGame({ query })">
          <div class="room-item-no-border" :key="room.roomID" v-for="(room) in searchedGames">
            <div>
              <span class="action" @click="enterRoom(room)">{{ room.title }} ({{ room.sizeX }}x{{ room.sizeY }})</span>
            </div>
          </div>
        </div> -->

        <div>
          <div>
            <h1 class="centertext">
              Featured Public Rooms
            </h1>
            <input placeholder="Find Your Cell Game Room with Search 🔍" class="cell-game-room" type="text" v-model="query" @input="searchGame({ query })">
            <div class="gap"></div>
            <div class="grey-area">
              <div class="game-items">
                <div class="search" v-if="!!query || query !== ''">
                  <div class="game-room-block" :key="room.roomID" v-for="(room) in searchedGames">
                    <div class="game-title action" @click="enterRoom(room)">
                      <span v-if="room.enableEntryPassword">
                        <img class="inline-icon" src="./cj/password.svg" alt="">
                      </span>
                      {{ room.title }} <img class="inline-icon" src="./img/goright.svg" />
                    </div>

                    <div class="game-room-size">
                      <span>
                        <img class="inline-icon" src="./img/player.svg" alt="">
                      </span>
                      <span>
                        Player: {{ room.counter }}
                      </span>
                    </div>

                    <div class="game-room-size">
                      Room Size: {{ room.sizeX }}x{{ room.sizeY }}
                    </div>
                  </div>
                </div>


                <div v-if="!query || query === ''">
                  <div class="game-room-block vh-center" v-if="rooms.filter(r => r.pinned).length === 0">
                    Loading...
                  </div>
                  <div class="game-room-block" :key="room.roomID" v-for="(room) in rooms.filter(r => r.pinned)">
                    <div class="game-title action" @click="enterRoom(room)">
                      <span v-if="room.enableEntryPassword">
                        <img class="inline-icon" src="./cj/password.svg" alt="">
                      </span>
                      {{ room.title }} <img class="inline-icon" src="./img/goright.svg" alt="">
                    </div>

                    <div class="game-room-size">
                      <span>
                        <img class="inline-icon" src="./img/player.svg" alt="">
                      </span>
                      <span>
                        Player: {{ room.counter }}
                      </span>
                    </div>

                    <div class="game-room-size">
                      Room Size: {{ room.sizeX }}x{{ room.sizeY }}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- <div class="room-item-no-border" :key="room.roomID" v-for="(room) in searchedGames">
              <div>
                <span class="action" @click="enterRoom(room)">{{ room.title }} ({{ room.sizeX }}x{{ room.sizeY }})</span>
              </div>
            </div> -->
          </div>
        </div>
        <!--
        <h3>Pinned Games</h3>

        <div class="lobby-list">
          <div class="room-list">
            <div class="room-item-no-border" :key="room.roomID" v-for="(room) in rooms.filter(r => r.pinned)">
              <span class="action" @click="enterRoom(room)">{{ room.title }} ({{ room.sizeX }}x{{ room.sizeY }})</span>
            </div>
          </div>
        </div> -->

        <!--

          <h2>Official Games</h2>
          <div class="lobby-list">
            <div class="room-list">
              <div class="room-item-no-border" :key="room.roomID" v-for="(room) in rooms">
                <span class="action" @click="enterRoom(room)">{{ room.title }} ({{ room.sizeX }}x{{ room.sizeY }})</span>
              </div>
            </div>
          </div>
        -->

        <!-- <div class="tab-btns">
          <div class="tab-button" v-if="role === 'teacher'" @click="show = 'mygame'">
            Teacher's Game
          </div>
          <div class="tab-button" v-if="role === 'teacher'" @click="show = 'search-game'">
            Search
          </div>
        </div> -->



        <!-- <div v-if="isOneOfAdmin && !isProd">
          <h2>Developer Area</h2>
          <pre>{{ rooms }}</pre>
          <pre>{{ admins }}</pre>
        </div> -->
      </div>
    </div>
  </div>

</template>

<script>
import { State } from '../game/auth.js'
import { FDB, toArr } from '../game/firebase.js'
import * as Auth from '../game/auth.js'
import { setTimeout, setInterval, clearInterval } from 'timers';
// const hastagR = require('hashtag-regex')
// let tags = String('#easy #summer-2014').match(hastagR())
import _ from 'lodash'

export default {
  components: {
    GameMenu: require('../game-ui/GameMenu.vue').default
  },
  props: {
    role: {}
  },
  data () {
    return {
      show: 'search-game',
      query: '',
      isProd: process.env.NODE_ENV === 'production',
      pinnedGames: require('./pinned.json'),
      rooms: [],
      admins: [],
      mygames: [],
      searchedGames: [],
      isOneOfAdmin: false,
      config: {
        sizeX: 75,
        sizeY: 75
      },
      items:[
        { sizeX: 10, sizeY: 10 },
        { sizeX: 25, sizeY: 25 },
        { sizeX: 75, sizeY: 75 },
        { sizeX: 200, sizeY: 200 }
      ],
      mapPeopleCount: new Map()
      // result: false
    }
  },
  mounted () {
    this.$on('logo', () => {
      window.open('https://sites.google.com/view/cell-game')
    })
    this.$on('twitter', () => {
      window.open('https://twitter.com/the_cell_game')
    })
    this.$on('game-rule', () => {
      window.open('https://sites.google.com/view/cell-game/rules')
    })
    this.$on('chat', () => {
      window.open('https://yoteachapp.com/lab/Cell_game_feedback')
    })
    this.$on('logout', () => {
      Auth.logout()
      window.location.assign('/')
    })

    this.listAdminRooms()
  },
  methods: {
    listAdminRooms () {
      FDB.ref(`/admin-games`).on('value', (snap) => {
        this.rooms = toArr(snap.val())
        console.log(this.rooms)
        this.rooms.forEach((room, idx) => {

          FDB.ref('/players/' + room.roomID + '/players').once('value', (snap) => {
            let val = snap.val()
            this.rooms[idx] = {
              ...room,
              counter: Object.keys(val).length
            }
            this.$forceUpdate()
          })
        })

        // if (this.$route.query.retry) {
        //   let room = this.rooms.find(e => e._id === this.$route.query.retry)
        //   if (room) {
        //     this.$emit('room', room)
        //   }
        // }

        // setTimeout(() => {
        //
        // }, 1000)
        // debug
        // this.$emit('room', this.rooms[this.rooms.length - 1])
      })
      // if (this.$route.query.retry) {
      //   FDB.ref(`/user-games/${this.$route.query.retry}`).on('value', (snap) => {
      //       let room = snap.val()

      //       // let room = roomss.find(e => e._id === this.$route.query.retry)
      //       if (room) {
      //         this.$emit('room', room)
      //       }

      //     // setTimeout(() => {
      //     //
      //     // }, 1000)
      //     // debug
      //     // this.$emit('room', this.rooms[this.rooms.length - 1])
      //   })
      // }
    },
    searchGame: _.throttle(function ({ query }) {
      FDB.ref(`/user-games`).orderByChild('title').startAt(query).limitToFirst(25).once('value', (snap) => {
        let value = snap.val()
        this.searchedGames = toArr(value)

        this.searchedGames.forEach((room, idx) => {

          FDB.ref('/players/' + room.roomID + '/players').once('value', (snap) => {
            let val = snap.val()
            this.searchedGames[idx] = {
              ...room,
              counter: Object.keys(val || {}).length
            }
            this.$forceUpdate()
          })
        })
      })
    }, 300),

    enterRoom (room) {
      this.$emit('room', room)
    }
  }

}
</script>

<style scoped>
.full{
  width: 100%;
  height: 100%;
}
.overlay{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

.lobby{
  /* background-color: rgba(0, 0, 0, 0.603); */
  font-size: 20px;
  color: white;

  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.lobby a,
.lobby a:visited,
.lobby a:hover,
.lobby a:active {
  color: white;
}
.lobby-wrapper{
  margin: 30px;
}
.lobby-title{
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 30px;
}
.lobby-list{
}
.action{
  cursor: pointer;
}


.toolbar{
  display: flex;
  flex-direction: column;
  width: calc(100% - 1px * 2);
  padding: 1px;
  padding-top: 0px;
  text-align: left;
}
.toolbar-title{
  font-size: 21px;
  margin-top: 10px;
  order: 2;
}
.toolbar-buttons{
  order: 1;
}

.toolbar-icon{
  margin-left: 10px;
  height: 30px;
}

@media screen and (min-width: 767px) {

    .toolbar-title{
      order: 1;
    }
    .toolbar-buttons{
      order: 2;
    }
   .toolbar{
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: space-between;
   }
   .toolbar-icon{
     height: 40px;
  }
}

.cell-game-room{
  margin-top: 20px;
  appearance: none;
  border: none;
  box-shadow: none;
  outline: none;
  padding: 15px;
  width: calc(100% - 15px * 2);
  border-radius: 30px;
  font-size: 20px;
}
@media screen and (min-width: 767px) {
  .cell-game-room{
    display: block;
    max-width: 600px;
    margin: 20px auto;
  }
}
.searchbox{
}
.center-v{
  display: flex;
  align-items: center;
  justify-content: center;
}
.gap{
  width: 100%;
  height: 10px;
}
.grey-area{
  border-radius: 30px;
  width: calc(100% - 10px * 2.0);
  padding: 10px 10px;

  margin-top: 30px;
  background-color: rgba(113, 113, 113, 0.671);
  max-width: 600px;
  margin: 0px auto;
}

.game-room-block{
  padding: 10px;
  border-radius: 20px;
  margin: 5px 5px;
  width: calc(100% - 2 * 10px - 5px * 2);
  color: black;
  background-color: white;
}

@media screen and (min-width: 767px) {
  .game-room-block{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.game-title{
  padding: 10px 0px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;

}

@media screen and (min-width: 767px) {
  .game-title{
    width: 250px;
  }
}
.game-room-size{
  font-size: 12px;
  padding: 10px;
  border: red dashed 1px;
  border-radius: 10px;
  margin: 10px 0px;
}

.inline-icon{
  cursor: pointer;
  height: 12px;
}
.vh-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.centertext{
  text-align: center;
}
</style>
